module.exports = __webpack_public_path__ + "img/active-25.12b3af75.svg";